export const handleDownloadAttachment = async (attachmentUrl, attachmentName) => {
  try {
    const response = await fetch(attachmentUrl, { mode: 'cors' });
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = attachmentName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error(error);
  }
};